import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Link as RouterLink } from 'react-router-dom';
import { AppProvider } from '@shopify/polaris';
import en from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import './App.css';
import store from './Store';
import AppFrame from './components/Layout/AppFrame';
import Routes from './Routes';

//Polaris links/buttons with `url` use the router for in-app paths (no full page reload)
const LinkComponent = ({ children, url = '', external, ...rest }) => {
  if (external || /^(https?:|mailto:|tel:)/i.test(url)) {
    return <a href={url} target="_blank" rel="noopener noreferrer" {...rest}>{children}</a>;
  }
  return <RouterLink to={url} {...rest}>{children}</RouterLink>;
};

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <AppProvider i18n={en} linkComponent={LinkComponent}>
        <AppFrame>
          <Routes />
        </AppFrame>
      </AppProvider>
    </BrowserRouter>
  </Provider>
);

export default App;
